/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitalBills } from 'app/entities/hospital-bill/hospital-bill.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getOPCharges } from 'app/entities/op-charge/op-charge.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getOpProcedureOrders } from 'app/entities/op-procedure-order/op-procedure-order.reducer';
import { getEntities as getOpProcedureOrderItems } from 'app/entities/op-procedure-order-item/op-procedure-order-item.reducer';
import { getEntities as getPatientCategories } from 'app/entities/patient-category/patient-category.reducer';
import { getEntities as getMiscCharges } from 'app/entities/misc-charges/misc-charges.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';
import { createEntity, getEntity, reset, updateEntity } from './hospital-op-bill-item.reducer';

export const HospitalOPBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitalBills = useAppSelector(state => state.hospitalBill.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const oPCharges = useAppSelector(state => state.oPCharge.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const opProcedureOrders = useAppSelector(state => state.opProcedureOrder.entities);
  const opProcedureOrderItems = useAppSelector(state => state.opProcedureOrderItem.entities);
  const patientCategories = useAppSelector(state => state.patientCategory.entities);
  const miscCharges = useAppSelector(state => state.miscCharges.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const hospitalOPBillItemEntity = useAppSelector(state => state.hospitalOPBillItem.entity);
  const loading = useAppSelector(state => state.hospitalOPBillItem.loading);
  const updating = useAppSelector(state => state.hospitalOPBillItem.updating);
  const updateSuccess = useAppSelector(state => state.hospitalOPBillItem.updateSuccess);
  const billTypeValues = Object.keys(BillType);

  const handleClose = () => {
    navigate(`/hospital-op-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitalBills({}));
    dispatch(getAppointments({}));
    dispatch(getDiaglabBills({}));
    dispatch(getOPCharges({}));
    dispatch(getPharmacyBills({}));
    dispatch(getOpProcedureOrders({}));
    dispatch(getOpProcedureOrderItems({}));
    dispatch(getPatientCategories({}));
    dispatch(getMiscCharges({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.multiplier !== undefined && typeof values.multiplier !== 'number') {
      values.multiplier = Number(values.multiplier);
    }
    if (values.qty !== undefined && typeof values.qty !== 'number') {
      values.qty = Number(values.qty);
    }
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }

    const entity = {
      ...hospitalOPBillItemEntity,
      ...values,
      bill: hospitalBills.find(it => it.id.toString() === values.bill?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      labBill: diaglabBills.find(it => it.id.toString() === values.labBill?.toString()),
      opService: oPCharges.find(it => it.id.toString() === values.opService?.toString()),
      pharmacyBill: pharmacyBills.find(it => it.id.toString() === values.pharmacyBill?.toString()),
      order: opProcedureOrders.find(it => it.id.toString() === values.order?.toString()),
      orderItem: opProcedureOrderItems.find(it => it.id.toString() === values.orderItem?.toString()),
      patientCategory: patientCategories.find(it => it.id.toString() === values.patientCategory?.toString()),
      miscCharge: miscCharges.find(it => it.id.toString() === values.miscCharge?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          billType: 'OP',
          ...hospitalOPBillItemEntity,
          bill: hospitalOPBillItemEntity?.bill?.id,
          appointment: hospitalOPBillItemEntity?.appointment?.id,
          labBill: hospitalOPBillItemEntity?.labBill?.id,
          opService: hospitalOPBillItemEntity?.opService?.id,
          pharmacyBill: hospitalOPBillItemEntity?.pharmacyBill?.id,
          order: hospitalOPBillItemEntity?.order?.id,
          orderItem: hospitalOPBillItemEntity?.orderItem?.id,
          patientCategory: hospitalOPBillItemEntity?.patientCategory?.id,
          miscCharge: hospitalOPBillItemEntity?.miscCharge?.id,
          scheme: hospitalOPBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospitalOPBillItem.home.createOrEditLabel" data-cy="HospitalOPBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.home.createOrEditLabel">
              Create or edit a HospitalOPBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-op-bill-item-id"
                  label={translate('tinyMedicRestApp.hospitalOPBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.description')}
                id="hospital-op-bill-item-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.totalCost')}
                id="hospital-op-bill-item-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.paidAmount')}
                id="hospital-op-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.discount')}
                id="hospital-op-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.billType')}
                id="hospital-op-bill-item-billType"
                name="billType"
                data-cy="billType"
                type="select"
              >
                {billTypeValues.map(billType => (
                  <option value={billType} key={billType}>
                    {translate(`tinyMedicRestApp.BillType.${billType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.active')}
                id="hospital-op-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.microSec')}
                id="hospital-op-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.timestampEntry')}
                id="hospital-op-bill-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.lastUpdated')}
                id="hospital-op-bill-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.cursor')}
                id="hospital-op-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.miscellaneous')}
                id="hospital-op-bill-item-miscellaneous"
                name="miscellaneous"
                data-cy="miscellaneous"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.multiplier')}
                id="hospital-op-bill-item-multiplier"
                name="multiplier"
                data-cy="multiplier"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.qty')}
                id="hospital-op-bill-item-qty"
                name="qty"
                data-cy="qty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalOPBillItem.chargedMrp')}
                id="hospital-op-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
              />
              <ValidatedField
                id="hospital-op-bill-item-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.bill')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalBills
                  ? hospitalBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-labBill"
                name="labBill"
                data-cy="labBill"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.labBill')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-opService"
                name="opService"
                data-cy="opService"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.opService')}
                type="select"
              >
                <option value="" key="0" />
                {oPCharges
                  ? oPCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-pharmacyBill"
                name="pharmacyBill"
                data-cy="pharmacyBill"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.pharmacyBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.order')}
                type="select"
              >
                <option value="" key="0" />
                {opProcedureOrders
                  ? opProcedureOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-orderItem"
                name="orderItem"
                data-cy="orderItem"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.orderItem')}
                type="select"
              >
                <option value="" key="0" />
                {opProcedureOrderItems
                  ? opProcedureOrderItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-patientCategory"
                name="patientCategory"
                data-cy="patientCategory"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.patientCategory')}
                type="select"
              >
                <option value="" key="0" />
                {patientCategories
                  ? patientCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-miscCharge"
                name="miscCharge"
                data-cy="miscCharge"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.miscCharge')}
                type="select"
              >
                <option value="" key="0" />
                {miscCharges
                  ? miscCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-op-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.hospitalOPBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/hospital-op-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalOPBillItemUpdate;
